module.exports = __webpack_public_path__ + "images/bug_dark_blue_size_6_9da0db1b56577d8e0c8d65c48753d0ab.png";